import React from 'react';

type PicksComponentProps = {
  children: JSX.Element;
};

function Picks({ children }: PicksComponentProps) {
  return <div className="picks__route">{children}</div>;
}

export default Picks;
